export default __webpack_public_path__ + "static/media/desktop-snippet-index-route.94b3be92.jpg";